import {
  GET_SCREEN_DETAILS,
  GET_SCREEN_DETAILS_SUCCESS,
  GET_SCREEN_DETAILS_FAIL,
  UPDATE_SCREEN_DETAILS,
  UPDATE_SCREEN_DETAILS_SUCCESS,
  UPDATE_SCREEN_DETAILS_FAIL,
} from "./actionTypes";

const initialState = {
  errorMessage: null,
  successMessage: null,
  loader: false,
  screenDetails: null,
};

const screenReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCREEN_DETAILS:
      state = {
        ...state,
        loader: true,
        errorMessage: null,
        screenDetails: null,
        successMessage:null
      };
      break;
    case GET_SCREEN_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        screenDetails: action.payload,
        errorMessage:null
      };
      break;
    case GET_SCREEN_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        screenDetails: null,
        errorMessage: action.payload,
      };
      break;
    case UPDATE_SCREEN_DETAILS:
      state = {
        ...state,
        loader: true,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case UPDATE_SCREEN_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        errorMessage: null,
        successMessage: action.payload,
      };
      break;
    case UPDATE_SCREEN_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        successMessage: null,
        errorMessage: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default screenReducer;
